import { useEffect, type RefObject } from 'react';

let observer: IntersectionObserver | null = null;

function watch(element: HTMLElement) {
  if (typeof IntersectionObserver === 'undefined') {
    element.dataset.visible = '';
    element.dataset.entered = '';
    return () => {};
  }

  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const target = entry.target as HTMLElement;
          if (entry.isIntersecting) {
            target.dataset.visible = '';
            if (target.dataset.entered === undefined) target.dataset.entered = '';
          } else {
            delete target.dataset.visible;
          }
        }
      },
      { rootMargin: '140px' },
    );
  }

  observer.observe(element);
  return () => {
    observer?.unobserve(element);
    delete element.dataset.visible;
  };
}


export function useCardPresence(ref: RefObject<HTMLElement | null>, enabled: boolean) {
  useEffect(() => {
    const element = ref.current;
    if (!element || !enabled) return;
    return watch(element);
  }, [ref, enabled]);
}
